import {cleanDigitsField} from "./cleanDigitsField";

function cleanPhoneNumber(number: string, removePrefix: boolean = false): string {
    if (!number) {
        return number
    }

    let clearestNumber = cleanDigitsField(number)
    const phoneDigits = clearestNumber[0] == "+" ? clearestNumber.slice(1) : clearestNumber

    if (phoneDigits.length == 11 && phoneDigits[0] == "8") {
        const replaceIndex = clearestNumber[0] == "+" ? 1 : 0
        clearestNumber = setCharAt(clearestNumber, replaceIndex, "7")
    }

    if (removePrefix && clearestNumber[0] == "+") {
        clearestNumber = clearestNumber.slice(1)
    }

    return clearestNumber
}

function setCharAt(str: string ,index: number, chr: string) {
    if(index > str.length-1) return str;
    return str.substring(0,index) + chr + str.substring(index+1);
}

export default cleanPhoneNumber
